import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { MaskedLines, FadeUp } from "@/components/Reveal";
import { DagazMark } from "@/components/Logo";

export default function ThankYou() {
    return (
        <>
            <Seo
                title="Thank You | Dagaz Development"
                description="Your message has been received."
                path="/thank-you"
                noindex
            />
            <section className="min-h-[85vh] flex flex-col justify-center px-6 md:px-12 lg:px-16 pt-24 bg-chalk" data-testid="thank-you-page">
                <FadeUp>
                    <DagazMark className="w-12 h-12 text-graphite mb-10" />
                </FadeUp>
                <MaskedLines
                    lines={["Thank you.", "It's with us now."]}
                    as="h1"
                    className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight text-graphite"
                />
                <FadeUp delay={0.5} className="mt-10 max-w-lg">
                    <p className="font-sans text-base md:text-lg leading-relaxed text-slate">
                        Your brief has been sent and a confirmation is on its way to your inbox. Every brief is read personally — expect an answer within two business days.
                    </p>
                </FadeUp>
                <FadeUp delay={0.65} className="mt-12">
                    <Link
                        to="/"
                        data-testid="thank-you-home-link"
                        className="group inline-flex items-center gap-3 px-8 py-4 bg-forest text-chalk font-sans text-xs font-semibold tracking-[0.22em] uppercase transition-colors duration-500 hover:bg-graphite"
                    >
                        Back to Home
                        <span className="inline-block transition-transform duration-500 group-hover:translate-x-1.5" aria-hidden="true">→</span>
                    </Link>
                </FadeUp>
            </section>
        </>
    );
}
